const action = "raid";

const RAID_SUCCESS_CHANCE = 0.9;

const RAID_MIN_AMMO_COST = 10;
const RAID_MAX_AMMO_COST = 10;
const RAID_MIN_HEALTH_COST = 10;
const RAID_MAX_HEALTH_COST = 10;

const RAID_MAX_FOOD_GAIN = 20;
const RAID_MAX_COINS_GAIN = 50;
const RAID_MAX_AMMO_GAIN = 30;

const messageText = ({ success, cost, gain }) => {
  if (!success) return `the raid was repulsed`;

  const { food, coins, ammo } = gain;
  return `looted **${food || "no"}** food,
  	**${coins || "no"}** coin${coins === 1 ? "" : "s"} and
  	**${ammo || "no"}** ammo.
  	lost **${cost.ammo}** ammo and **${cost.health}** health
  `;
};

const value = (max) => Math.floor(Math.random() * max);

const attempt = () => {
  const result = {
    success: Math.random() < RAID_SUCCESS_CHANCE,
    gain: {
      food: 0,
      coins: 0,
      ammo: 0,
    },
    cost: {
      ammo: Math.min(RAID_MIN_AMMO_COST, value(RAID_MAX_AMMO_COST)),
      health: Math.min(RAID_MIN_HEALTH_COST, value(RAID_MAX_HEALTH_COST)),
    },
  };

  if (!result.success) return result;

  result.gain.food += value(RAID_MAX_FOOD_GAIN);
  result.gain.ammo += value(RAID_MAX_AMMO_GAIN);
  result.gain.coins += value(RAID_MAX_COINS_GAIN);
  result.success = result.gain.food || result.gain.ammo || result.gain.coins;
  return result;
};

const executeSideEffects = (context, result) => {
  const {
    calendar,
    political,
    party,
  } = context;
  const { resources, history, traits, territory } = party;

  // History
  history.add({ action, day: calendar.step, result });

  // Update resources
  resources.delta({ ...result.gain }, context);

  // Infamy
  political.raid(territory, traits.getTraitValue("charisma"));

  // An armed raid on a settlement is the loudest thing the party can do. The law is on the
  // trail from here to the far side of the region.
  party.markPursued();

  const message = { label: messageText(result), id: new Date() };
  return { message };
};

const raid = (notifyDone) => ({
  title: "Raid",
  enabled: ({ party }) =>
    party.resources.attribs.ammo.value >= RAID_MAX_AMMO_COST &&
    party.resources.attribs.health.value >= RAID_MAX_HEALTH_COST,
  execute: (context) => {
    const result = attempt(context);
    const { message } = executeSideEffects(context, result);

    notifyDone();

    return { result: { message } };
  },
  tooltips: [
    ["health", `${RAID_MIN_HEALTH_COST} - ${RAID_MAX_HEALTH_COST}`],
    ["ammo", `${RAID_MIN_AMMO_COST} - ${RAID_MAX_AMMO_COST}`],
  ],
});

export { action as RaidType, raid as default };
